
import { SimpleSpriteSwap } from '../../modules/symbol/SimpleSpriteSwap';
import { SymbolMultiplyCounter } from '../../modules/symbol/SymbolMultiplyCounter';
import { SanSymbolData } from './SanSymbolData';



export class SanSplittedSym extends SimpleSpriteSwap {

    private txtValue: SymbolMultiplyCounter;

    private size:number = 4;

    public get symbolHeight(): number {
        return SanSymbolData.fetchSymHeightSize(this.size);
    }

    public get symbolWidth(): number {
        return SanSymbolData.DEFAULT_DIM.WIDTH;
    }

    constructor(_texture:PIXI.Texture, multVal?:number,_size?:number) {
        super(_texture);
        if(_size) this.size = _size;
        if(multVal){
            this.txtValue = this.addChild(new SymbolMultiplyCounter(multVal));
            this.txtValue.position.x =  this.symbolWidth/(multVal >= 10 ? 4 : 3.25);
            if(this.size != 1)
                this.txtValue.position.y = this.symbolHeight/(this.size == 4 ? 3 : 4);
        }
    }
    public setTexturePos(sizeType: number): void {
        this.size = sizeType;
        if(this.txtValue){
            this.txtValue.position.y = this.size ===  1 ? 0 : this.symbolHeight/(this.size == 4 ? 3 : 4);
        }
    }
}
